/** Dialog shown during advanced RX creation when user tries to deselect data layers */

import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

// @tcc
import { getMessage } from 'util/locale';

// selectors
import { getLayerInclusionModal } from 'current/uiwidgets/selectors';

// actions
import { closeLayerInclusionModal } from 'current/uiwidgets';
import { excludeLayers } from 'advanced';

// components
import BaseModal from 'common/modals/BaseModal';
import HtmlText from 'html-text/HtmlText';

const baseString = 'vra-layer-inclusion-modal';
let LayerInclusionModal = ({
  layerInclusionModal,
  onKeepLayers,
  onRemoveLayers,
}) => {
  if (!layerInclusionModal) {
    return null;
  }

  const layersCount = layerInclusionModal.length || 1;

  return (
    <BaseModal
      cancelText={getMessage('button-text__keep-layer', { layersCount })}
      onCancel={onKeepLayers}
      onSave={() => onRemoveLayers(layerInclusionModal)}
      saveText={getMessage('button-text__remove-layer', { layersCount })}>
      <div className={baseString}>
        <header>{getMessage('title-text__layer-inclusion-modal')}</header>
        <HtmlText messageKey='text__layer-inclusion-modal' />
      </div>
    </BaseModal>
  );
};

LayerInclusionModal.propTypes = {
  layerInclusionModal: propTypes.oneOf([propTypes.object, propTypes.array]),
  onKeepLayers: propTypes.func.isRequired,
  onRemoveLayers: propTypes.func.isRequired
};

LayerInclusionModal = connect(
  (state) => {
    return {
      layerInclusionModal: getLayerInclusionModal(state)
    };
  },
  (dispatch) => {
    return {
      onRemoveLayers: (layers) => {
        dispatch(excludeLayers(layers));
        dispatch(closeLayerInclusionModal());
      },
      onKeepLayers: () => {
        dispatch(closeLayerInclusionModal());
      }
    };
  }
)(LayerInclusionModal);

export default LayerInclusionModal;
